import { BrowserCapability } from './protocol';

export interface CustomWidgetEdgeConfig {
  /** Environment base, e.g. https://app.finxone.dev. The origin key is prepended as a host label. */
  baseUrl: string;
  /** `<namespace>~<web-frontend-service>`, supplied by the owning deployment system. */
  route: string;
}

export function intersectBrowserCapabilities(
  placed: readonly BrowserCapability[] | undefined,
  current: readonly BrowserCapability[] | undefined,
): BrowserCapability[] {
  const currentSet = new Set(current ?? []);
  return (placed ?? []).filter(
    (capability, index, values) => currentSet.has(capability) && values.indexOf(capability) === index,
  );
}

export function browserCapabilitiesAllow(capabilities: readonly BrowserCapability[]): string {
  return capabilities.map((capability) => `${capability} 'src'`).join('; ');
}

export function buildCustomWidgetEdgeUrl(
  config: CustomWidgetEdgeConfig,
  originKey: string,
  slug: string,
  version: string,
): string {
  if (!/^[a-z2-7]{26}$/.test(originKey)) {
    throw new Error('Invalid custom-widget origin key');
  }
  const base = new URL(config.baseUrl);
  if (base.protocol !== 'https:' && base.hostname !== 'localhost') {
    throw new Error('Custom-widget edge must use HTTPS outside localhost');
  }
  if (!/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?~[a-z0-9](?:[a-z0-9-]{0,50})-web-frontend$/.test(config.route)) {
    throw new Error('Invalid custom-widget project route');
  }
  base.hostname = `w${originKey}.${base.hostname}`;
  const path = [config.route, originKey, slug, version, 'runner.html']
    .map((segment) => encodeURIComponent(segment))
    .join('/');
  base.pathname = `/${path}`;
  base.search = '';
  base.hash = '';
  return base.toString();
}
